import {
  WebAppStationDto,
  WebAppStationDtoAccessTypeEnum,
  WebAppStationDtoAccessTypeEnumKey,
  WebAppStationDtoTypeEnum,
  WebAppStationDtoTypeEnumKey,
  WebAppStationGroupDto,
  WebAppStationGroupDtoAccessTypeEnum,
  WebAppStationGroupDtoAccessTypeEnumKey,
} from '@mi-front/api-v2';

export type MediaFormat = 'aac' | 'mp3' | 'mpegts' | 'fmp4';

export type StationType = WebAppStationDtoTypeEnumKey;
export const StationType = WebAppStationDtoTypeEnum;
export type StationAccessType = WebAppStationDtoAccessTypeEnumKey;
export const StationAccessType = WebAppStationDtoAccessTypeEnum;
export type StationGroupAccessType = WebAppStationGroupDtoAccessTypeEnumKey;
export const StationGroupAccessType = WebAppStationGroupDtoAccessTypeEnum;

export type WatermarkConfig = {
  enabled?: boolean;
  imageUrl?: string;
  positionX?: string;
  positionY?: string;
  paddingX?: number;
  paddingY?: number;
  opacity?: number;
};

export interface FragmentTagGroup {
  name: string;
  tags: string[];
  default: boolean;
}

/**
 * Station returned by the app API, including its application feature configuration.
 * Omits DTO `featuresConfig`/`format` so nested `any` from codegen cannot pollute app types.
 */
export type Station = Omit<WebAppStationDto, 'format' | 'featuresConfig'> & {
  format: MediaFormat;
  featuresConfig: FeaturesConfig;
};

type FeaturesConfig = {
  audit: {
    enabled: boolean;
    liveMentionsEnabled: boolean;
  };
  transcription: {
    diarization: { segments: boolean; fragments: boolean };
    enabled: boolean;
  };
  fragments: {
    platformUpload: Record<
      string,
      {
        enabled: boolean;
      }
    >;
    descriptionFooters?: {
      name: string;
      content: string;
      default: boolean;
    }[];
    mediaWatermark?: WatermarkConfig;
    tagGroups?: FragmentTagGroup[];
  };
  streamerBox?: {
    deviceId?: string;
  };
  videoAnalysis: {
    faceRecognition: { enabled: boolean };
    lowerThird: { enabled: boolean };
    adOverlays: { enabled: boolean };
    enabled: boolean;
  };
  export?: {
    enabled?: boolean;
  };
};

/** Minimal station shape nested under station groups in api-v2. */
export type MinimumStation = NonNullable<WebAppStationGroupDto['stations']>[number];

export type MinimumStationsGroup = WebAppStationGroupDto;
